import { fetchRecommendationSuggestions } from 'actions/SearchActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import useRecommendationPlaceIds from './useRecommendationPlaceIds'

const emptyArray: Array<App.SearchItemV3> = []

function useRecommendationSuggestions(): Array<App.SearchItemV3> {
  const dispatch = useAppDispatch()
  const placeIds = useRecommendationPlaceIds()
  const key = placeIds.join(',')

  useEffect(() => {
    if (key) {
      dispatch(fetchRecommendationSuggestions(key.split(',')))
    }
  }, [dispatch, key])

  const suggestions = useAppSelector(state =>
    key ? state.search.recommendationSuggestions[key] : undefined,
  )

  return suggestions ?? emptyArray
}

export default useRecommendationSuggestions
